<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productAutoresponders"
  >

    <blockquote class="quote quote-products-primary quote-first">
      <p>
        <span v-if="academiaAutoresponders.length === 0">
          {{ $t('mEditionProductAutorespondersLists.quote.firstTextAutoresponders') }}
        </span>
        <span v-if="academiaAutoresponders.length === 0">
          {{ $t('mEditionProductAutorespondersLists.quote.secondTextAutoresponders') }}
        </span>
        <span v-if="academiaAutoresponders.length > 0 && productoAutorespondersListas.length === 0">
          {{ $t('mEditionProductAutorespondersLists.quote.firstTextAutorespondersLists') }}
        </span>
        <span v-if="academiaAutoresponders.length > 0">
          {{ $t('mEditionProductAutorespondersLists.quote.secondTextAutorespondersLists') }}
        </span>
      </p>
    </blockquote>

    <AtomButtonSecondary
      v-if="!academiaAutoresponders.length"
      :button-secondary="buttonSecondary.associateAutoresponder"
      @showModal="$modal.showModal"
    />

    <AtomButtonSecondary
      v-if="academiaAutoresponders.length"
      :button-secondary="buttonSecondary.associateAutoresponderList"
      @showModal="$modal.showModal"
    />

    <div
      v-if="productoAutorespondersListas.length"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionProductAutorespondersLists.table.thList') }}
          </th>
          <th class="text-align-left">
            {{ $t('mEditionProductAutorespondersLists.table.thAccount') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductAutorespondersLists.table.thAutoresponder') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionProductAutorespondersLists.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="lista in productoAutorespondersListas"
          :key="lista.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ lista.nombre }}
          </td>
          <td class="text-align-left">
            {{ getCuentaDescripcion(lista.academia_autoresponder.id_academia_autoresponder) }}
          </td>
          <td class="text-align-center">
            {{ getCuentaAutoresponderNombre(lista.academia_autoresponder.id_academia_autoresponder) }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="lista"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductAutorespondersLists',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object
  },

  data () {
    return {
      academiaAutoresponders: [],
      academiaId: '',

      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductAutorespondersListsModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductAutorespondersLists.tooltip.delete'),
          type: 'button'
        }
      },

      buttonSecondary: {
        associateAutoresponder: {
          class: 'a-button-products-secondary a-button-side',
          component: 'MoleculeEditionAcademyAutorespondersModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionProductAutorespondersLists.buttonSecondary.associateAutoresponderText'),
          type: 'button'
        },

        associateAutoresponderList: {
          class: 'a-button-products-secondary',
          component: 'MoleculeEditionProductAutorespondersListsModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionProductAutorespondersLists.buttonSecondary.associateAutoresponderListText'),
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productoAutorespondersListas: [],
      showLoadingState: true
    }
  },

  watch: {
    'element.autoresponders' () {
      this.productoAutorespondersListas = this.element.autoresponders
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readAcademiaAutoresponders()
    this.productoAutorespondersListas = this.element.autoresponders
  },

  methods: {
    getCuentaAutoresponderNombre (academiaAutoresponderId) {
      return this.academiaAutoresponders.find(cuenta => cuenta.id_academia_autoresponder === academiaAutoresponderId).autoresponder.nombre
    },

    getCuentaDescripcion (academiaAutoresponderId) {
      return this.academiaAutoresponders.find(cuenta => cuenta.id_academia_autoresponder === academiaAutoresponderId).descripcion
    },

    readAcademiaAutoresponders () {
      this.$services.read('academia', 'readAcademiaAutoresponders', {}, [this.academiaId])
        .then(response => {
          this.academiaAutoresponders = response.data
          this.pagination.currentQuantity = this.academiaAutoresponders.length
          this.pagination.totalQuantity = this.academiaAutoresponders.length
          console.log(response.data)
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
